import { Grid, IconButton } from '@mui/material';
import { styles } from './styles';
import { IActivityFeedClose } from './types';
import RightArrow from 'assets/icons/buttons/activity-feed-arrow.svg';

export const ActivityFeedClose = ({ onClose }: IActivityFeedClose) => {
  return (
    <Grid sx={styles.closeIconContainer}>
      <IconButton onClick={onClose}>
        <RightArrow />
      </IconButton>
    </Grid>
  );
};
